import { motion } from 'framer-motion';
import { Heart, Linkedin, Instagram, Youtube, Mail } from 'lucide-react';

export const PersonalFooter = ({ contact }) => {
  const socialLinks = [
    { icon: Linkedin, href: contact.linkedin, label: 'LinkedIn' },
    { icon: Instagram, href: contact.instagram, label: 'Instagram (Personal)' },
    { icon: Instagram, href: contact.happylab, label: 'Happy Lab Instagram' },
    { icon: Youtube, href: contact.youtube, label: 'YouTube' },
    { icon: Mail, href: `mailto:${contact.email}`, label: 'Email' },
  ];

  return (
    <footer className="bg-gray-900 dark:bg-black text-white py-16 px-6 sm:px-12 lg:px-16">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="text-3xl font-bold bg-gradient-to-r from-amber-400 to-rose-400 bg-clip-text text-transparent mb-4">
              Vandana S.
            </h3>
            <p className="text-gray-400 leading-relaxed">
              Helping people understand themselves better through psychology, storytelling and education.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider mb-4 text-gray-500">
              Explore
            </h4>
            <ul className="space-y-2">
              {['Work', 'Content', 'Writing', 'Speaking', 'Collaborate'].map((link) => (
                <li key={link}>
                  <a
                    href={`#${link.toLowerCase()}`}
                    className="text-gray-400 hover:text-white transition-colors duration-300 inline-block hover:translate-x-1 transform"
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider mb-4 text-gray-500">
              Connect
            </h4>
            <div className="flex gap-3">
              {socialLinks.map((social) => (
                <motion.a
                  key={social.label}
                  href={social.href}
                  whileHover={{ scale: 1.1, y: -2 }}
                  whileTap={{ scale: 0.95 }}
                  className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-amber-600 transition-all duration-300 group"
                  aria-label={social.label}
                >
                  <social.icon className="w-5 h-5 text-gray-400 group-hover:text-white transition-colors" />
                </motion.a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Vandana S. All rights reserved.
          </p>
          <p className="text-gray-500 text-sm flex items-center gap-2">
            Made with <Heart className="w-4 h-4 text-rose-500 fill-rose-500" /> and curiosity
          </p>
        </div>
      </div>
    </footer>
  );
};
